if (!customElements.get('scrolling-banner')) {
  const ScrollingBanner = class extends HTMLElement {
    constructor() {
      super();
      this.isPlaying = true;
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      // Transforms can confuse lazy loading in browsers, so we coordinate loading here
      // Load all countdown timers
      customElements.whenDefined('countdown-timer').then(() => {
        this.querySelectorAll('countdown-timer').forEach((el) => el.init());
      });

      // Load all images
      this.querySelectorAll('img[loading="lazy"]').forEach((el) => {
        el.loading = 'eager';
      });

      // After fonts have loaded
      document.fonts.ready.then(() => {
        this.querySelector('.marquee').classList.add('marquee--animate');
        this.initPlayPauseButton();
      });
    }

    /**
     * Initialize the play/pause button for animation control
     */
    initPlayPauseButton() {
      this.playPauseBtn = this.querySelector('.marquee-play-pause');
      if (!this.playPauseBtn) return;

      this.marquee = this.querySelector('.marquee');
      if (!this.marquee) return;

      this.playPauseBtn.addEventListener('click', this.toggleAnimation.bind(this));
    }

    /**
     * Toggle animation play/pause state
     */
    toggleAnimation() {
      this.isPlaying = !this.isPlaying;

      if (this.isPlaying) {
        this.marquee.classList.remove('marquee--paused');
        this.playPauseBtn.setAttribute('aria-pressed', 'false');
        this.playPauseBtn.setAttribute('aria-label', this.playPauseBtn.dataset.labelPause);
        this.playPauseBtn.textContent = this.playPauseBtn.dataset.textPause;
      } else {
        this.marquee.classList.add('marquee--paused');
        this.playPauseBtn.setAttribute('aria-pressed', 'true');
        this.playPauseBtn.setAttribute('aria-label', this.playPauseBtn.dataset.labelPlay);
        this.playPauseBtn.textContent = this.playPauseBtn.dataset.textPlay;
      }
    }
  };

  window.customElements.define('scrolling-banner', ScrollingBanner);
}
